import localization from '@/constant/localization';
import { useEffect, useState } from 'react';
import Retry from '@/components/otp/retry';
import OtpProps from '@/components/otp/type';
import Container from '@/components/@base/container';
import { COLOR_ENUM, INPUT_TYPES, SIZE_ENUM } from '@/components/@base/@types';
import { Text } from '@/components/@base/typography';
import Input from '@/components/@base/input/text';
import Button from '@/components/@base/button';
import { convertToEnglishNumber, isMerchantUpg } from '@/lib/helper';
import Skeleton from '@/components/@base/skeleton';
import ozoneLogoDark from '@/assets/logos/ozoneLogo-dark.svg';
import ozoneLogoLight from '@/assets/logos/ozoneLogo-light.svg';
import useHomeStore from '@/store/home';
import cn from '@/lib/clsxm';
import ThreeDotLoading from '@/components/@base/three-dot-loading/ThreeDotLoading';
import { useGetAdvertisement } from '@/services/hooks';
import { useSearchParams } from 'react-router-dom';

const OTP = ({ phoneNumber, submittedOtp, isLoading, btnLoading, otpExpireDate }: OtpProps) => {
  const mUpgData = sessionStorage.getItem('mUpg') ? JSON.parse(sessionStorage.getItem('mUpg')!) : null
  const [OTP, setOTP] = useState('');
  const { otpTokenLength } = useHomeStore();
  const [searchParams] = useSearchParams();
  const {data:advertise} = useGetAdvertisement(9, searchParams.get('pgc') as string)
  const {data:advertiseInOtp} = useGetAdvertisement(10, searchParams.get('pgc') as string)
  const handleSetOTP = (e:any) => {
    if(!isNaN(+convertToEnglishNumber(e.target.value))) setOTP(e.target.value);
    // if (e.target.value.length === otpTokenLength && !isNaN(+e.target.value)) submittedOtp(e.target.value);
  };
  const clearOtpField = () => {
    setOTP('')
  }

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        } as CredentialRequestOptions)
        .then((otp) => {
          if (otp && "code" in otp) {
            setOTP(otp.code as string);
          }
        })
        .catch((err) => {
          console.error("Failed to retrieve OTP:", err);
        });

      return () => ac.abort();
    }
  }, []);
  useEffect(() => {
    if(OTP?.length === otpTokenLength) submittedOtp(OTP)
  }, [OTP]);
  if (isLoading)
    return (
      <Container
        center
        className={cn('fixed bottom-0 left-0 right-0 top-0 bg-grayLight-0 dark:bg-grayLight-990')}
      >
        <Container center className='flex-col items-center'>
          <img src={ozoneLogoDark} className="hidden dark:block"/>
          <img src={ozoneLogoLight} className="dark:hidden"/>
          {advertise && advertise?.ads?.length > 0 && advertise?.ads[0]?.banner && advertise?.ads[0]?.banner?.length > 0 && (
            <Container className="fixed z-10 bottom-12 max-w-[448px] px-4">
              <Container className='relative'>
                <img
                  src={advertise?.ads[0]?.banner}
                  alt='ads'
                  className={cn('min-h-10 w-full rounded-lg')}
                />
              </Container>
            </Container>
          )}
          <ThreeDotLoading/>
        </Container>
      </Container>
    );
  return (
    <Container className='relative w-full flex flex-col mt-2 grow'>
      <Container
        center
        className='w-full flex-col pt-6'
      >
        <Container className='flex w-full flex-col gap-2'>
          <Text size={SIZE_ENUM.LG} className='text-grayLight-1000 dark:text-white text-center w-full' medium>
            {isMerchantUpg() ? localization.customGateway(mUpgData.title) :localization.goToOzoneGateway}
          </Text>
          <Text
            size={SIZE_ENUM.SM}
            className='rtl mb-4 text-grayLight-1000 dark:text-grayLight-200 text-center'
          >
            {localization.verificationCodeText1}
            {phoneNumber ? (
              <span className='mx-1'>{phoneNumber}</span>
            ) : (
              <Skeleton
                className='mx-1 w-20 bg-grayLight-100/10 dark:bg-grayLight-800/80'
                baseColor={'bg-grayLight-800/30'}
              />
            )}
            {localization.verificationCodeText2}
          </Text>
          <Input
            autoComplete='one-time-code'
            maxLength={otpTokenLength}
            size={SIZE_ENUM.XL}
            placeholder={localization.onTimePass}
            value={OTP}
            onChange={handleSetOTP}
            className={cn(
              'border-grayLight-40 border-[2px] bg-grayLight-40 text-grayLight-800 focus:!border-black dark:border-grayDark-750 dark:bg-grayDark-750 dark:text-white dark:focus:!border-grayLight-30')}
            type={INPUT_TYPES.TEL}
          />
        </Container>
      </Container>
      <Retry
        otpExpireDate={otpExpireDate}
        phoneNumber={phoneNumber}
        clearOtpField={clearOtpField}
      />
      {!isMerchantUpg() && (
        <Text className='mt-4 text-center text-[13px] text-grayLight-700 dark:text-grayLight-200'>
          {' '}
          ورود/ثبت نام شما به منزله پذیرش{' '}
          <a
            target='_blank'
            className='text-black dark:text-white font-medium'
            href='https://pwa.ozone.ir/terms-of-service'
          >
            شرایط استفاده
          </a>{' '}
          و{' '}
          <a
            target='_blank'
            className='text-black dark:text-white font-medium'
            href='https://pwa.ozone.ir/privacy-policy'
          >
            قوانین حریم خصوصی
          </a>{' '}
          اوزون می‌باشد.{' '}
        </Text>
      )}
      <Button
        className='m-auto mt-6 w-full max-w-[430px] rounded-full mb-4 iSE:mb-0'
        size={SIZE_ENUM.XL}
        color={COLOR_ENUM.PRIMARY}
        onClick={() => submittedOtp(OTP)}
        disabled={OTP?.length < otpTokenLength || btnLoading}
        isLoading={btnLoading}
      >
        {localization.confirm}
      </Button>

      {advertiseInOtp && advertiseInOtp?.ads?.length > 0 && advertiseInOtp?.ads[0]?.banner && advertiseInOtp?.ads[0]?.banner?.length > 0 && (
        <Container className="iSE:absolute bottom-[68px] z-50 max-w-[430px] w-full pb-6 iSE:pb-0">
          <Container className='relative'>
            <img
              src={advertiseInOtp?.ads[0]?.banner}
              alt='ads'
              className={cn('min-h-10 w-full rounded-lg')}
            />
          </Container>
        </Container>
      )}
    </Container>
  );
};
export default OTP;
